import { useRef } from "react";
import ImgTag from "@/components/Helpers/ImgTag";
import CloseIcon from "@/components/icons/CloseIcon";

function getNextMonthIndex(currentMonthIndex) {
  let nextMonthIndex = currentMonthIndex + 2;

  if (nextMonthIndex <= 12) {
    return nextMonthIndex;
  } else if (nextMonthIndex === 13) {
    return 0; // January
  } else if (nextMonthIndex === 14) {
    return 1; // February
  }
}

const MispayModal = ({ amount, locale, show, setShow }) => {
  const options = [
    {
      "title-ar": "أضف العنصر إلى سلة التسوق الخاصة بك",
      "title-en": "Add the item to your cart",
      icon: "cart",
    },
    {
      "title-ar": "حدد MISPAY عند الخروج",
      "title-en": "Select MISPAY at checkout",
      icon: "select-mispay",
    },
    {
      "title-ar": "املأ التفاصيل الخاصة بك",
      "title-en": "Fill in your details",
      icon: "fill-form",
    },
    {
      "title-ar": "أكمل دفعتك الأولى",
      "title-en": "Complete your first payment",
      icon: "pay",
    },
  ];
  const months = [
    { index: 0, "name-en": "Jan", "name-ar": "يناير", lastDay: "31" },
    { index: 1, "name-en": "Feb", "name-ar": "فبراير", lastDay: null }, // Placeholder for dynamically determining last day
    { index: 2, "name-en": "Mar", "name-ar": "مارس", lastDay: "31" },
    { index: 3, "name-en": "Apr", "name-ar": "أبريل", lastDay: "30" },
    { index: 4, "name-en": "May", "name-ar": "مايو", lastDay: "31" },
    { index: 5, "name-en": "Jun", "name-ar": "يونيو", lastDay: "30" },
    { index: 6, "name-en": "Jul", "name-ar": "يوليو", lastDay: "31" },
    { index: 7, "name-en": "Aug", "name-ar": "أغسطس", lastDay: "31" },
    { index: 8, "name-en": "Sep", "name-ar": "سبتمبر", lastDay: "30" },
    { index: 9, "name-en": "Oct", "name-ar": "أكتوبر", lastDay: "31" },
    { index: 10, "name-en": "Nov", "name-ar": "نوفمبر", lastDay: "30" },
    { index: 11, "name-en": "Dec", "name-ar": "ديسمبر", lastDay: "31" },
  ];

  // Dynamically determine last day of February 31 st th
  const februaryLastDay = new Date(new Date().getFullYear(), 1, 0).getDate();
  months[1].lastDay = februaryLastDay; // "st" for February
  const currentMonthIdx = new Date().getMonth();
  const ref = useRef();

  console.log(`months[getNextMonthIndex(currentMonthIdx + 1)]?.lastDay`, months[getNextMonthIndex(currentMonthIdx + 1)]?.lastDay)
  return (
    <>
      {show ? (
        <div
          ref={ref}
          className="w-screen max-[768px]:w-[90vw] max-[991px]:w-8/12 max-w-[800px] max-[991px]:max-h-[70vh] overflow-hidden max-[768px]:h-[80vh] shadow-lg max-[991px]:h-[614px] rounded-xl fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[999999] bg-white flex flex-col gap-6 items-center justify-center max-[991px]:justify-between"
        >
          <CloseIcon
            onClick={() => setShow(false)}
            className="absolute start-4 top-4"
          />
          <ImgTag
            src="/imgs/mispay.svg"
            className="w-[100px] h-auto object-contain mt-10"
            alt="Mispay logo"
            width={100}
            height={100}
          />{" "}
          <p className="mx-4 text-lg font-bold text-center">
            {locale === "ar"
              ? "قم بتقسيم مشترياتك إلى 4 دفعات بدون فوائد، وبدون رسوم تأخير. متوافق مع الشريعة الإسلامية."
              : "Split your purchase into 4 interest-free payments, No late fees. sharia-compliant."}
          </p>
          <div className="flex justify-center gap-4 max-[991px]:gap-6 relative">
            <div className="absolute top-4 left-1/2 -translate-x-1/2 h-[2px] bg-[#6322D0] w-10/12 z-0" />
            {[1, 2, 3, 4]?.map((item, idx) => (
              <div
                key={"mis-" + idx}
                className="z-10 flex flex-col items-center gap-4"
              >
                <div className="size-9 rounded-full border-2 border-[#6322D0] bg-white flex items-center justify-center">
                  {item}
                </div>
                <p className="flex flex-col justify-center text-center">
                  <span>
                    {(amount / 4)?.toFixed(2)}{" "}
                    {locale === "ar" ? " ر.س" : "SAR"}
                  </span>
                  {item === 1 && (
                    <span className="text-[12px]">
                      {locale === "ar" ? "اليوم" : "Today"}
                    </span>
                  )}
                  {item === 2 && (
                    <span className="text-[12px]">
                      {
                        months?.[getNextMonthIndex(currentMonthIdx)]?.[
                          "name-" + locale
                        ]
                      }{" "}
                      {`${months[
                        getNextMonthIndex(currentMonthIdx)
                      ]?.lastDay}`?.concat(
                        locale === "en"
                          ? months[getNextMonthIndex(currentMonthIdx)]
                              ?.lastDay === "31"
                            ? "st"
                            : "th"
                          : ""
                      )}
                    </span>
                  )}
                  {item === 3 && (
                    <span className="text-[12px]">
                      {
                        months?.[getNextMonthIndex(currentMonthIdx + 1)]?.[
                          "name-" + locale
                        ]
                      }{" "}
                      {`${months[
                        getNextMonthIndex(currentMonthIdx + 1)
                      ]?.lastDay}`?.concat(
                        locale === "en"
                          ? months[getNextMonthIndex(currentMonthIdx + 1)]?.lastDay === "31"
                            ? "st"
                            : "th"
                          : ""
                      )}
                    </span>
                  )}
                  {item === 4 && (
                    <span className="text-[12px]">
                      {
                        months?.[getNextMonthIndex(currentMonthIdx + 2)]?.[
                          "name-" + locale
                        ]
                      }{" "}
                      {`${months[
                        getNextMonthIndex(currentMonthIdx + 2)
                      ]?.lastDay}`?.concat(
                        locale === "en"
                          ? months[getNextMonthIndex(currentMonthIdx + 2)]
                              ?.lastDay === "31"
                            ? "st"
                            : "th"
                          : ""
                      )}
                    </span>
                  )}
                </p>
              </div>
            ))}
          </div>
          <div className="p-10 bg-[#faf9f9] w-full">
            <p className="font-bold text-center">
              {locale === "ar" ? "كيفية استخدام MISPay" : "How to use MISPay"}
            </p>
            <div className="grid grid-cols-2 gap-4 mt-4 max-[991px]:grid-cols-4">
              {options?.map((opt) => (
                <div key={opt.icon} className="flex flex-col gap-4">
                  <div className="flex items-center justify-center">
                    <ImgTag
                      src={`/imgs/mispay/${opt.icon}.svg`}
                      alt={opt["title-" + locale]}
                      className="h-[18px] object-contain"
                      width={100}
                      height={100}
                    />
                  </div>
                  <p className="text-base text-center">
                    {opt["title-" + locale]}
                  </p>
                </div>
              ))}
            </div>
            <button
              onClick={() => setShow(false)}
              className="bg-[#6322D0] hover:bg-[#53d3d7]  rounded-lg w-[232px] h-[40px] flex items-center justify-center text-white mx-auto mt-10"
            >
              {locale === "ar" ? "مواصلة التسوق" : "Continue Shopping"}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default MispayModal;
